import request from '@/config/request'

export default {
    sendSmsMessage: function (mobile) {
        return request({
            url: '/message/smsmessage/sendsmsmessage',
            method: 'post',
            params: {
                mobile: mobile,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/message/textmessage.js